import styled from 'styled-components';
import { colors } from '../colors';

interface checkboxProps {
	filterItemSelect?: boolean;
	projectIndividualSelect?: boolean;
	projectIndividualSelectAll?: boolean;
	specialtySelect?: boolean;
	rememberMe?: boolean;
}

const Checkbox = styled.div<checkboxProps>`
	display: inline-block;
	> input {
		opacity: 0;
		width: 0px;
		height: 0px;
	}
	label {
		font-size: 15px;
		line-height: 20px;
		color: ${colors.Grey};
		padding-left: 35px !important;
		padding-top: 4px !important;
	}
	> input + label {
		position: relative;
		padding-left: 25px;
		cursor: pointer;
		font-size: 14px;
		padding-top: 2px;
		&:before {
			content: '';
			position: absolute;
			left: 0;
			top: 1px;
			width: 20px;
			height: 20px;
			border: 1px solid ${colors.Grey};
			background: ${colors.White};
			border-radius: 4px;
		}
		&:after {
			content: url(${require('../../assets/images/tickicon.svg')});
			position: absolute;
			top: 2px;
			left: 4px;
			font-size: 12px;
			width: 12px;
			height: 10px;
			color: ${colors.White};
			transition: all 0.2s;
		}
	}
	> input:not(:checked) + label {
		&:after {
			opacity: 0;
			transform: scale(0);
		}
	}

	> input:checked + label {
		&:after {
			opacity: 1;
			transform: scale(1);
		}
		&:before {
			background: ${colors.BlueBase};
			border: 2px solid ${colors.BlueBase}!important;
		}
	}
	> input:disabled + label {
		pointer-events: none;
		&:after {
			opacity: 0;
			pointer-events: none;
		}
		&:before {
			background: ${colors.BlueBase};
			pointer-events: none;
		}
	}
	> input:disabled {
		pointer-events: none;
	}
	> input:checked:focus + label,
	input:not(:checked):focus + label {
		&:before {
			border: 1px solid ${colors.BlueBase};
			background: ${colors.White};
		}
	}
	${({ filterItemSelect }) =>
		filterItemSelect &&
		`position: absolute;
		right:10px;
		top: 12px;
		label{
			padding-left: 21px !important;
		}
	`}
	${({ projectIndividualSelect }) =>
		projectIndividualSelect &&
		`label{
			padding-left: 27px !important;
			:before{
				width: 16px!important;
				height: 16px!important;
				border: 2px solid  ${colors.Grey58}!important;
				border-radius: 3px!important;
				top:4px!important;
			}
			:after{
				top: 2px!important;
				left: 2px!important;
			}
		}
		> input + label {
			&:after {
				content: url(${require('../../assets/images/smallTick.svg')})!important;
			}
		}
	`}
	${({ projectIndividualSelectAll }) =>
		projectIndividualSelectAll &&
		`label{
			padding-left: 27px !important;
			font-size: 14px !important;
			line-height: 17px !important;
			:before{
				width: 16px!important;
				height: 16px!important;
				border: 2px solid  ${colors.Grey58}!important;
				border-radius: 3px;
				top: 2px!important;
			}
			:after{
				top: 2px!important;
				left: 2px!important;
				content: url(${require('../../assets/images/smallTick.svg')})!important;
			}
		}
		> input + label {
			&:after {
				content: url(${require('../../assets/images/smallTick.svg')})!important;
			}
		}
	`}
	${({ specialtySelect }) =>
		specialtySelect &&
		`margin-bottom:16px;
            label{
                font-size: 15px!important;
                line-height: 20px;
                color: ${colors.BlueDark};
                padding-left: 35px!important;
                padding-top: 2px!important;
            }
	`}
	${({ rememberMe }) =>
		rememberMe &&
		`width:100%;
		border: 1px solid ${colors.White};
		box-sizing: border-box;
		border-radius: 4px;
		padding:0;
		margin-top:23px;
		text-align:left;
		label{
			font-size: 13px!important;
			line-height: 20px!important;
			color: ${colors.BlueDark};
			padding-left: 30px!important;
			padding-top: 5px!important;
			@media (max-width:530px){
				padding-left: 28px!important;
			}
		}
		:hover{
			border: 1px solid ${colors.White};
			background: ${colors.White};
			label{
				color:${colors.BlueDark};
			}
		}
	`}
	
`;

export default Checkbox;
